import LazyLoad from './Lazyload'

export default LazyLoad
